import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OnInit, Inject, Component } from '@angular/core';

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
    standalone: false
})
export class ConfirmDialogComponent implements OnInit {

  acceptButtonText: string;
  declineButtonText: string;
  alternateButtonText: string;
  hideCancelButton: boolean = false;
  hideAlternateButton: boolean = true;

  constructor(public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.acceptButtonText = this.data.acceptButtonText ? this.data.acceptButtonText : 'Okay';
    this.declineButtonText = this.data.declineButtonText ? this.data.declineButtonText : 'Cancel';
    this.alternateButtonText = this.data.alternateButtonText ? this.data.alternateButtonText : '';
    this.alternateButtonText = this.data.alternateButtonText ? this.data.alternateButtonText : '';
    this.hideCancelButton = this.data.hideCancelButton ? this.data.hideCancelButton : false;
    this.hideAlternateButton = !this.alternateButtonText;
    this.hideAlternateButton = !this.alternateButtonText;
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onAlternate(): void {
    this.dialogRef.close(this.data.alternateButtonValue ?? 'alternate');
  }

  onConfirm(): void {
    this.dialogRef.close(this.data.acceptButtonValue ?? true);
    this.dialogRef.close(this.data.acceptButtonValue ?? true);
  }

}